import { render, staticRenderFns } from "./CustomerShow.vue?vue&type=template&id=7e50509e&scoped=true&"
import script from "./CustomerShow.vue?vue&type=script&lang=js&"
export * from "./CustomerShow.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShow.vue?vue&type=style&index=0&id=7e50509e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50509e",
  null
  
)

export default component.exports